// default component views
import ModelEdit from '@/components/base/Edit'
import ModelCreate from '@/components/base/Create'
import ModelList from '@/components/base/List'
import BaseWidget from '@/components/widgets/Base'
import ComponentView from '@/components/base/ComponentView'
import CodeEditor from "@/components/form/Editor/Code"
import QRCode from 'qrcode.vue'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

// ui components
import VSelect from 'vue-select'
import Field from './Field'
import DefaultField from './DefaultField'
import Draggable from 'vuedraggable'

// media ui
import MediaLibrary from '@/components/integrations/protokol/media/Index'
import AppView from '@/views/apps/AppView'


export default {
    ModelEdit,
    ModelCreate,
    ModelList,
    VSelect,
    BaseWidget,
    MediaLibrary,
    Field,
    DefaultField,
    ComponentView,
    Draggable,
    CodeEditor,
    QRCode,
    QRCodeStream: QrcodeStream,
    QRCodeDropZone: QrcodeDropZone,
    QRCodeCapture: QrcodeCapture,
    AppView
}